// extracted by mini-css-extract-plugin
export var addToCartButton = "_t4-b";
export var arrowButtonContainer = "_t4-9";
export var arrowButtonIcon = "_t4-a";
export var carouselArrowButton = "_t4-6";
export var carouselElementContainer = "_t4-1";
export var galleryThumbnail = "_t4-d";
export var galleryThumbnailImage = "_t4-e";
export var left = "_t4-7";
export var productDisplayCarouselContainer = "_t4-0";
export var productTileContainer = "_t4-2";
export var productTileImage = "_t4-4";
export var productTileImageContainer = "_t4-3";
export var productTileTitle = "_t4-5";
export var right = "_t4-8";
export var sliderOverflow = "_t4-c";